var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlltrips(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 9.5H6.33333M8 12.8333H6.33333M13 6.16667H6.33333M16.3333 6V14.6667C16.3333 16.0668 16.3333 16.7668 16.0608 17.3017C15.8212 17.7721 15.4387 18.1545 14.9683 18.3942C14.4335 18.6667 13.7335 18.6667 12.3333 18.6667H7C5.59987 18.6667 4.8998 18.6667 4.36503 18.3942C3.89462 18.1545 3.51217 17.7721 3.27248 17.3017C3 16.7668 3 16.0668 3 14.6667V6C3 4.59987 3 3.8998 3.27248 3.36503C3.51217 2.89462 3.89462 2.51217 4.36503 2.27248C4.8998 2 5.59987 2 7 2H12.3333C13.7335 2 14.4335 2 14.9683 2.27248C15.4387 2.51217 15.8212 2.89462 16.0608 3.36503C16.3333 3.8998 16.3333 4.59987 16.3333 6Z",
    stroke: "#757575",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlltrips);
export default __webpack_public_path__ + "static/media/alltrips.6feeb886146927d21ef668e348d49052.svg";
export { ForwardRef as ReactComponent };